"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const CustomTypeModelSliceType = {
  Slice: "Slice",
  SharedSlice: "SharedSlice"
};
exports.CustomTypeModelSliceType = CustomTypeModelSliceType;
//# sourceMappingURL=sliceZone.cjs.map
